// removed by extract-text-webpack-plugin
module.exports = {"inner":"inner-f0jUo","slim":"slim-31Nd4 slim-2C1LB","error":"error-59sfB inputError-2jP1m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/BirthdateField/_birthdateField.css
// module id = 1186
// module chunks = 1